module.exports = __webpack_public_path__ + "static/media/PDF_113.254dd5db.pdf";